export default __webpack_public_path__ + "static/media/img-2.71369f86.jpg";